import { useContext } from "react";
import { MdArrowOutward, MdClose, MdLocationPin } from "react-icons/md";
import { AppContext } from "../App";
import { company, navigationItems } from "../siteContent";

export default function SideBar(props) {
  const appContext = useContext(AppContext);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({ item });

    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  return (
    <div className="SideBar mShadow2" data-open={appContext.isSideBarOpen}>
      <div className="body mNoScrollBar">
        <div className="d-flex justify-content-between align-items-start sidebar-header">
          <div>
            <img src={company.logo} alt={company.shortName} className="sidebar-logo rounded-pill" />
            <h6 className="font-bold text-primary mt-3 mb-1">{company.shortName}</h6>
            <p className="font-light mNoMargin">{company.tagline}</p>
          </div>
          <button className="btn btn-light btn-rounded sidebar-close-btn" onClick={appContext.closeSideBar}>
            <MdClose size={24} />
          </button>
        </div>

        <div className="sidebar-contact-card">
          <div className="d-flex">
            <MdLocationPin size={22} className="text-secondary me-2 mt-1" />
            <div>
              <p className="font-semi-bold mNoMargin">Based in Zanzibar</p>
              <p className="font-light mNoMargin">{company.location}</p>
            </div>
          </div>
        </div>

        {navigationItems.map((nav) => (
          <div
            key={nav.item}
            className="pill"
            onClick={() => {
              goTo(nav.item);
            }}
            data-active={appContext.navItem === nav.item || (!appContext.navItem && nav.item === "home")}
          >
            <p className="text">{nav.label}</p>
            <MdArrowOutward size={20} className="sidebar-pill-arrow" />
          </div>
        ))}

        <div className="sidebar-cta-box">
          <p className="font-semi-bold text-primary mb-2">Need a custom itinerary?</p>
          <p className="font-light mb-3">We plan beach holidays, cultural tours, safaris, and combined Tanzania journeys.</p>
          <button className="btn btn-primary btn-rounded btn-block" onClick={() => goTo("contact_us")}>
            Start with Our Team
          </button>
        </div>
      </div>
    </div>
  );
}
